import React, {useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {CircularProgress, Box} from '@mui/material';
import {useAuth} from '../AuthContext';

export default function LandingAuthRedirect() {
 const {isAuthenticated}=useAuth(); const location=useLocation(); const {i18n}=useTranslation();
 useEffect(()=>{
  if(isAuthenticated)return;
  const origin=process.env.REACT_APP_LANDING_URL || 'https://indicatorai.io';
  const locale=i18n.language?.startsWith('vi')?'vi':'en';
  const target=new URL('/'+locale+(location.pathname==='/register'?'/register':'/login'),origin);
  const from=location.state?.from;
  if(from?.pathname?.startsWith('/')&&!from.pathname.startsWith('//') && window.location.hostname === 'app.indicatorai.io') {
   const destination=window.location.origin+from.pathname+(from.search||'')+(from.hash||'');
   document.cookie='indicatorai_auth_return='+encodeURIComponent(destination)+'; Domain=indicatorai.io; Path=/; Max-Age=600; Secure; SameSite=Lax';
  }
  window.location.replace(target.href);
 },[isAuthenticated,location,i18n.language]);
 if(isAuthenticated)return <Navigate to="/" replace/>;
 return <Box sx={{display:'flex',justifyContent:'center',py:8}}><CircularProgress/></Box>;
}
